<p class="text-center py-2">Authenticator Code</p>
<ng-otp-input
  (onInputChange)="submitMfaOtp($event)"
  [config]="{
    allowNumbersOnly: true,
    length: 6,
    placeholder: '0',
    inputClass:
      'border max-sm:text-2xl! max-sm:mx-1! max-w-12 min-h-12 border-solid border-grey-concrete shadow rounded-3xl! ring-2 ring-transparent focus:outline-none focus:border-white focus:ring-primary transition-all h-12 placeholder-grey-concrete pt-2.5! aspect-13/16',
  }"
>
</ng-otp-input>
<div class="text-center py-2 font-normal my-6">
  <div>Having problems?</div>
  <a routerLink="/mfa-recovery" id="mfa-recovery" class="inline-block p-1 py-0.5 mt-0.5 btn-link text-primary"
    >Enter a recovery code</a
  >
</div>
<div class="mt-2 flex flex-col items-center justify-between gap-3">
  <a routerLink="/" class="btn-link text-primary text-base font-medium p-2">Back to login</a>
</div>
